import HELP_SOURCE_JODOO_EN_US from './jodoo_en_us.json';
import HELP_SOURCE_JODOO_ZH_TW from './jodoo_zh_tw.json';
import HELP_SOURCE_JDY_ZH_CN from './jdy_zh_cn.json';
// eslint-disable-next-line @fx-ui/jdy-design/import-path-restricted
import { LocaleRecord } from '~/interfaces';
import { LOCALE_KEY } from '@fx-ui/intl';

export const HELP_SOURCE_JDY: LocaleRecord<typeof HELP_SOURCE_JDY_ZH_CN> = {
    [LOCALE_KEY.ZH_CN]: HELP_SOURCE_JDY_ZH_CN,
    [LOCALE_KEY.ZH_TW]: HELP_SOURCE_JDY_ZH_CN,
    [LOCALE_KEY.EN_US]: HELP_SOURCE_JDY_ZH_CN,
    [LOCALE_KEY.JA_JP]: HELP_SOURCE_JDY_ZH_CN,
    [LOCALE_KEY.VI_VN]: HELP_SOURCE_JDY_ZH_CN,
    [LOCALE_KEY.RU_RU]: HELP_SOURCE_JDY_ZH_CN,
    [LOCALE_KEY.FR_FR]: HELP_SOURCE_JDY_ZH_CN,
    [LOCALE_KEY.ES_ES]: HELP_SOURCE_JDY_ZH_CN,
    [LOCALE_KEY.TH_TH]: HELP_SOURCE_JDY_ZH_CN,
    [LOCALE_KEY.ID_ID]: HELP_SOURCE_JDY_ZH_CN,
    [LOCALE_KEY.KO_KR]: HELP_SOURCE_JDY_ZH_CN,
    [LOCALE_KEY.DE_DE]: HELP_SOURCE_JDY_ZH_CN,
    [LOCALE_KEY.PT_PT]: HELP_SOURCE_JDY_ZH_CN,
    [LOCALE_KEY.KM_KH]: HELP_SOURCE_JDY_ZH_CN,
    [LOCALE_KEY.LO_LA]: HELP_SOURCE_JDY_ZH_CN,
    [LOCALE_KEY.HI_IN]: HELP_SOURCE_JDY_ZH_CN,
    [LOCALE_KEY.BN_BD]: HELP_SOURCE_JDY_ZH_CN,
    [LOCALE_KEY.TA_IN]: HELP_SOURCE_JDY_ZH_CN,
    [LOCALE_KEY.UZ_UZ]: HELP_SOURCE_JDY_ZH_CN,
    [LOCALE_KEY.MN_MN]: HELP_SOURCE_JDY_ZH_CN,
    [LOCALE_KEY.IT_IT]: HELP_SOURCE_JDY_ZH_CN,
    [LOCALE_KEY.NL_NL]: HELP_SOURCE_JDY_ZH_CN,
    [LOCALE_KEY.PL_PL]: HELP_SOURCE_JDY_ZH_CN,
    [LOCALE_KEY.HU_HU]: HELP_SOURCE_JDY_ZH_CN,
    [LOCALE_KEY.PT_BR]: HELP_SOURCE_JDY_ZH_CN
};

export const HELP_SOURCE_JODOO: LocaleRecord<typeof HELP_SOURCE_JDY_ZH_CN> = {
    [LOCALE_KEY.ZH_CN]: HELP_SOURCE_JODOO_EN_US,
    [LOCALE_KEY.ZH_TW]: HELP_SOURCE_JODOO_ZH_TW,
    [LOCALE_KEY.EN_US]: HELP_SOURCE_JODOO_EN_US,
    [LOCALE_KEY.JA_JP]: HELP_SOURCE_JODOO_EN_US, // 使用英文文档
    [LOCALE_KEY.VI_VN]: HELP_SOURCE_JODOO_EN_US, // 使用英文文档
    [LOCALE_KEY.RU_RU]: HELP_SOURCE_JODOO_EN_US, // 使用英文文档
    [LOCALE_KEY.FR_FR]: HELP_SOURCE_JODOO_EN_US, // 使用英文文档
    [LOCALE_KEY.ES_ES]: HELP_SOURCE_JODOO_EN_US, // 使用英文文档
    [LOCALE_KEY.TH_TH]: HELP_SOURCE_JODOO_EN_US, // 使用英文文档
    [LOCALE_KEY.ID_ID]: HELP_SOURCE_JODOO_EN_US, // 使用英文文档
    [LOCALE_KEY.KO_KR]: HELP_SOURCE_JODOO_EN_US, // 使用英文文档
    [LOCALE_KEY.DE_DE]: HELP_SOURCE_JODOO_EN_US, // 使用英文文档
    [LOCALE_KEY.PT_PT]: HELP_SOURCE_JODOO_EN_US, // 使用英文文档
    [LOCALE_KEY.KM_KH]: HELP_SOURCE_JODOO_EN_US,
    [LOCALE_KEY.LO_LA]: HELP_SOURCE_JODOO_EN_US,
    [LOCALE_KEY.HI_IN]: HELP_SOURCE_JODOO_EN_US,
    [LOCALE_KEY.BN_BD]: HELP_SOURCE_JODOO_EN_US,
    [LOCALE_KEY.TA_IN]: HELP_SOURCE_JODOO_EN_US,
    [LOCALE_KEY.UZ_UZ]: HELP_SOURCE_JODOO_EN_US,
    [LOCALE_KEY.MN_MN]: HELP_SOURCE_JODOO_EN_US,
    [LOCALE_KEY.IT_IT]: HELP_SOURCE_JODOO_EN_US,
    [LOCALE_KEY.NL_NL]: HELP_SOURCE_JODOO_EN_US,
    [LOCALE_KEY.PL_PL]: HELP_SOURCE_JODOO_EN_US,
    [LOCALE_KEY.HU_HU]: HELP_SOURCE_JODOO_EN_US,
    [LOCALE_KEY.PT_BR]: HELP_SOURCE_JODOO_EN_US
};
